<template>
  <div
    id="introduction"
    class="pc-assembly top-nav new"
    v-if="extras.groupIntroductionDisplay.display == 1"
    :style="{
      background:
        extras.introBg.colorOrBg == 'color'
          ? extras.introBg.color
          : 'url(' + extras.introBg.src + ')',
    }"
  >
    <div class="max">
      <Title
        v-if="extras && extras.IntroTitle.display == 1"
        :title="extras.IntroTitle.mainTitle || title"
        :en="extras.IntroTitle.subTitle || 'Introduction'"
        :extras="extras"
      ></Title>
      <div class="m-nodata-body" v-if="seminarInfo.desc.length == 0">
        <img src="@/assets/images/nodata.png" />
        <div class="m-nodata">{{ $t("暂无数据") }}</div>
      </div>
      <div
        class="text"
        v-html="
          $i18nField(
            seminarInfo.i18n && seminarInfo.i18n.seminar,
            'desc',
            seminarInfo.desc
          )
        "
      ></div>
    </div>
  </div>
</template>

<script>
import Title from "./Title.vue";
import i18nMixin from "../../mixins/i18n";

export default {
  name: "Header",
  mixins: [i18nMixin],
  props: {
    seminarInfo: Object,
    extras: Object,
  },
  components: {
    Title,
  },
  data() {
    return {
      title: "大会介绍",
      en: "Introduction",
      text: ``,
    };
  },
  mounted() {},
};
</script>

<style scoped></style>
